import { EntitiesStore } from './entities-store.abstract';
import { HttpClient, HttpParams } from '@angular/common/http';
import { tap, mergeMap, filter, map } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { EventGeneralInfoItem } from 'world-archery-lib';
import { WaHelperService } from '../../../library/wa-services/wa-helper-service';
import { CountryDependencyEntityStore } from './country-dependency-entity-store';
import { Injector } from '@angular/core';
import { CategoryCombo, RegionCombo, ComboStoreComponent } from '../filters-store/filters-store';
import { IMemberAssociation } from './member-association-store';


/**
 * The IRanking athlete.
 *
 * @export
 * @interface IRankingAthlete
 */
 export interface IRankingAthlete {
  Id: string;
  FName: string;
  GName: string;
  WNameOrd: boolean;
  NOC: string;
}

/**
 * The IWorldRanking interface.
 *
 * @export
 * @interface IWorldRanking
 */
export interface IWorldRanking {
  Rnk: number;
  RnkOld: number;
  Cat: string;
  Points: number;
  RnkDtIssued: string;
  RnkDtSince: string;
  Athlete: IRankingAthlete;
}

/**
 * Continental ranking store.
 *
 * @export
 * @class ContinentalRankingStore
 * @extends {ContinentalRankingStore<IContinentalRanking>}
 */
export class ContinentalRankingStore extends EntitiesStore<IRankingAthlete> {
  constructor(http: HttpClient, injector: Injector) {
    super('WORLDRANKINGS', http, [
      { entity: new CategoryCombo('', '', http), params:{'RBP': 'All'} },
    ]);
  }
}


export interface IWorldRankingCategory{
  Team: boolean;
  Cat: string;
}

/**
 * Continental category ranking store.
 *
 * @export
 * @class WorldRankingCategoriesStore
 * @extends {WorldRankingCategoriesStore<IContinentalRanking>}
 */
 export class WorldRankingCategoriesStore extends ComboStoreComponent<IWorldRankingCategory> {
  constructor(id:string, name:string,http: HttpClient, injector: Injector) {
    super(name, 'Name', id,  undefined, undefined, http, 'WORLDRANKINGSCATEGORIES', [], [
      { entity: new CategoryCombo('', '', http), params:{'RBP': 'All'} },
    ], true, 'category');
  }

  /**
   *
   * {@inheritdoc}
   */
  getRequest(params: any, request_more: boolean = false){
    return super.getRequest(params, request_more).pipe(
      map(a=> {
        const categoriesDependency = this.dependencies[0].entity.data;
        const filteredCategories = categoriesDependency
        .filter(value=> (a as any).items.findIndex(continentalCategory => continentalCategory.Cat === value.Code)> -1);
        this.data = filteredCategories;
        this.dataStream.next(this.data);
        console.log(this.data);
        (a as any).items = this.data;
        this.comboInfo.options_subject.next(this.data);
        this.comboInfo.options_selected_subject.next(this.data[0]);
        return a;
      })
    )
  }
}
